/**
 * Formats an IBAN string by inserting spaces every four characters
 * after the initial country code and check digits.
 * Example: DE11111111111111111111 -> DE11 1111 1111 1111 1111 11
 * It first cleans the input by removing existing spaces and non-alphanumeric
 * characters and converts it to uppercase.
 * @param iban The IBAN string to format. Can be null or undefined.
 * @returns The formatted IBAN string, or an empty string if the input is falsy.
 */
export function formatIban(iban: string | null | undefined): string {
    if (!iban) {
        return '';
    }

    const cleanedIban = iban.replace(/[\W_]+/g, '').toUpperCase();

    if (cleanedIban.length === 0) {
        return '';
    }

    const prefix = cleanedIban.substring(0, 4);
    const bban = cleanedIban.substring(4);

    const bbanGroups = bban.match(/.{1,4}/g);
    const formattedBban = bbanGroups ? bbanGroups.join(' ') : '';

    return formattedBban ? `${prefix} ${formattedBban}` : prefix;
}
